import { useGetGroupWhiteboardsQuery } from 'core/graphql';
import { transformGroupWhiteboards } from './transform';
import type { IWhiteboardMeta } from './transform';

interface IUseGroupWhiteboards {
  whiteboards: IWhiteboardMeta[];
  loading: boolean;
  error: string;
}

/**
 * All boards of a group (teacher-only continue picker). network-only so the
 * picker always shows fresh updatedAt ordering; `skip` lets the modal defer
 * the request until it is actually opened.
 */
export const useGroupWhiteboards = (groupId: string, skip = false): IUseGroupWhiteboards => {
  const { data, loading, error } = useGetGroupWhiteboardsQuery({
    fetchPolicy: 'network-only',
    variables: { groupId },
    skip: skip || !groupId,
  });

  return {
    whiteboards: transformGroupWhiteboards(data),
    loading,
    error: error?.message || '',
  };
};
